module.exports = "build/assets/mobileYellowPage.e828c04e.png";